"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SidebarButtonComponent_1 = __importDefault(require("../../components/sidebar/SidebarButtonComponent"));
class SidebarButtonPresenter {
    constructor(parentElement, text, clickCallback, isActive = false, iconTemplate = '') {
        this.parentElement = parentElement;
        this.component = new SidebarButtonComponent_1.default(text, iconTemplate, isActive);
        this.component.addOnClickListener(clickCallback);
        this.render();
    }
    render() {
        this.parentElement.append(this.component.getElement());
    }
}
exports.default = SidebarButtonPresenter;
